import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apply-design',
  templateUrl: './apply-design.component.html',
  styleUrls: ['./apply-design.component.css']
})
export class ApplyDesignComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
